<template>
    <div style="text-align: right;">
        <Page :total="total" 
            show-elevator 
            show-sizer 
            show-total 
            :current.sync="params.page" 
            :page-size="params.size" 
            @on-change="pageChange"
            @on-page-size-change="sizeChange"/>
    </div>
</template>
<script>
    import CompEventMixin from '@/utils/compEvent.mixin'
    export default {
        name: 'LyPage',
        mixins: [CompEventMixin],
        data () {
            return {
                total: 0,
                params: {
                }
            }
        },
        watch: {
            /**
             * atts变化 再次初始化查询参数
             */
            attrs: {
                handler () {
                    this.initSearchParams()
                },
                immediate: true
            }
        },
        methods: {
            /**
             * 初始化查询参数
             */
            initSearchParams () {
                this.total = 0
                this.$set(this, 'params', {
                    page: 1, // 当前页数
                    size: 20
                })
                // 初始化查询参数
                this.$eventHub.$emit(this.$events.INIT_SEARCH_PARAMS, this.params)
            },
            /**
             * 获得页面数据后的回调函数，在mixin的监听中调用
             */
            pageDataCallback () {
                // 设置总条数
                if (this.page && this.page.total) {
                    this.total = this.page.total
                } else {
                    this.total = 0
                }
                if (this.page && this.page.page) {
                    this.params.page = this.page.page
                } else {
                     this.params.page = 1
                }
            },
            /**
             * 每页条数的改变
             */
            sizeChange (size) {
                this.params.size = size
                //如果当前页码为1，需要手动触发
                if (this.params.page == 1) {
                    this.pageChange()
                }
            },
            /**
             * 页码的改变
             */
            pageChange () {
                // 发生搜索数据的事件
                this.$eventHub.$emit(this.$events.SEARCH_DATA, this.params)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// ../projectCore/src/components/page/src/index.vue